// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item-divider {
  min-height: 4px;
  max-height: 10px;
  margin-bottom: 4px;
}

ion-spinner {
  color: var(--ion-color-primary);
  width: 16px;
  height: 16px;
}

.end-icon {
  font-size: 16px;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/app/components/menus/menu-default/menu-default.component.scss"],"names":[],"mappings":"AACA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,+BAAA;EACA,WAAA;EACA,YAAA;AAAJ;;AAGA;EACI,eAAA;EACA,sBAAA;AAAJ","sourcesContent":["\r\nion-item-divider {\r\n    min-height: 4px;\r\n    max-height: 10px;\r\n    margin-bottom: 4px;\r\n}\r\n\r\nion-spinner {\r\n    color: var(--ion-color-primary);\r\n    width: 16px;\r\n    height: 16px;\r\n}\r\n\r\n.end-icon {\r\n    font-size: 16px;\r\n    vertical-align: middle;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
